"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CROSS_CHAIN_SUPPORTED_CHAINS = void 0;
const schemas_1 = require("@dcl/schemas");
exports.CROSS_CHAIN_SUPPORTED_CHAINS = [
    schemas_1.ChainId.MATIC_MUMBAI,
    schemas_1.ChainId.ETHEREUM_SEPOLIA,
    schemas_1.ChainId.ETHEREUM_MAINNET,
    schemas_1.ChainId.MATIC_MAINNET
];
//# sourceMappingURL=types.js.map